/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import React, { useCallback } from 'react';

import { LegalEntityAction } from '../../constants';
import {
  AccountProps,
  LegalEntityActionType,
  LegalEntityActions,
  LegalEntityProps,
  LegalEntityStateType,
} from '../../types';

import { useLegalEntityReducer } from './reducer';

interface UseActionsProps extends LegalEntityActions {
  state: LegalEntityStateType;
  dispatch: React.Dispatch<LegalEntityActionType>;
}

export const useActions = (): UseActionsProps => {
  const [state, dispatch] = useLegalEntityReducer();

  const setLegalEntities = useCallback(
    (legalEntities: LegalEntityProps[], count: number, error?: string): void =>
      dispatch({
        type: LegalEntityAction.SET_LEGAL_ENTITIES,
        legalEntities: legalEntities || [],
        count,
        error,
      }),
    [dispatch]
  );

  const setAccounts = useCallback(
    (accounts: AccountProps[]): void =>
      dispatch({
        type: LegalEntityAction.SET_ACCOUNTS,
        accounts: accounts || [],
      }),
    [dispatch]
  );

  const setLoadingLegalEntities = useCallback(
    (loading: boolean): void =>
      dispatch({
        type: LegalEntityAction.SET_LOADING_LEGAL_ENTITIES,
        loading,
      }),
    [dispatch]
  );

  const searchByName = useCallback(
    (name: string): void =>
      dispatch({
        type: LegalEntityAction.SEARCH_BY_NAME,
        name,
      }),
    [dispatch]
  );

  const searchByAccount = useCallback(
    (account: string): void =>
      dispatch({
        type: LegalEntityAction.SEARCH_BY_ACCOUNT,
        account,
      }),
    [dispatch]
  );

  const setSelectedLegalEntities = useCallback(
    (selectedLegalEntities: string[]): void =>
      dispatch({
        type: LegalEntityAction.SET_SELECTED_LEGAL_ENTITIES,
        selectedLegalEntities,
      }),
    [dispatch]
  );

  const paginate = useCallback(
    (page: number): void =>
      dispatch({
        type: LegalEntityAction.PAGINATE,
        page,
      }),
    [dispatch]
  );

  return {
    state,
    dispatch,
    setLegalEntities,
    setLoadingLegalEntities,
    searchByName,
    searchByAccount,
    setAccounts,
    setSelectedLegalEntities,
    paginate,
  };
};
